import React, { useEffect, useRef, useState } from "react";
import useFetch, { CachePolicies } from "use-http";
import axios from "axios";
import { Button, Modal, Popover } from "antd";
import { v4 as uuidv4 } from "uuid";
// get our fontawesome imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faPaperPlane, faPhotoVideo, } from "@fortawesome/free-solid-svg-icons";
import UIGroupSticker from "./UIGroupSticker";
import UIGroupAudio from "./UIGroupAudio";
import UIMessageInput from "./UIMessageInput";
import styles from "./ChatContentTab.module.scss";
import { expAudio, expImgges, expVideo, messageTypes, newExpURL, sendStatus, Service, } from "./ChatConstants";
import _ from "lodash";
import moment from "moment";
import stickerBtn from "./images/sticker.svg";
import unMic from "./images/microphone.svg";
import mic from "./images/UIChatRoom-mic.png";
import { useTranslation } from "react-i18next";
import { UserAPIEndpoint } from "../../../service/user.service";
import { getToken } from "../../../service/auth.service";
import { checkEmpty } from "src/service/util.service";
import { chunkSize, uploadFileRequestChunkChat, } from "src/service/files.service";
import { getClassAndType, getFinalNameChat } from "src/service/files.util";

const getAuthorization = () => {
    let token = getToken();
    let authorization = "Bearer " + token;

    return authorization;
};

function create_UUID() {
    var dt = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
    );
    return uuid;
}

const UIChatToolbar = (props) => {
    const { groupInfo, members } = props;
    const [messageRef, setRef] = useState(null);
    const [inputMessage, setInputMessage] = useState("");
    const refSticker = useRef(false);
    const refMic = useRef(false);
    const refFile = useRef(false);
    const refMedia = useRef(false);
    const refInputFile = useRef(false);
    const refInputMedia = useRef(false);
    const refSend = useRef(false);
    const { t } = useTranslation();
    const regexURL = new RegExp(newExpURL);
    const { warning } = Modal;
    const [loadingFile, setLoadingFile] = useState(false);

    const apiUploadFile = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + Service.FileSreviceUploadFile,
        {
            method: "post",
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );
    const apiDeleteFile = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + Service.FileSreviceDeleteFile,
        {
            method: "post",
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );
    const apiSaveMessageImage = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatSaveMessageImage,
        {
            method: "post",
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const blockedStatus = useFetch({
        path: UserAPIEndpoint.CheckBlockedAccount,
        cachePolicy: CachePolicies.NO_CACHE,
    });

    useEffect(() => {
        var textarea = document.querySelector("textarea");
        if (props.isSelect || props.IsSocketError) {
            textarea.disabled = true;
            refSticker.current.disabled = true;
            refFile.current.disabled = true;
            refMedia.current.disabled = true;
            if (refSend.current) {
                refSend.current.disabled = true;
            }
            if (refMic.current) {
                refMic.current.disabled = true;
            }
        } else {
            console.log("when an mount isSelect");
            textarea.removeAttribute("disabled");
            refSticker.current.removeAttribute("disabled");
            refFile.current.removeAttribute("disabled");
            refMedia.current.removeAttribute("disabled");
            if (refSend.current) {
                refSend.current.removeAttribute("disabled");
            }
            if (refMic.current) {
                refMic.current.removeAttribute("disabled");
            }
        }
    }, [props.isSelect, props.IsSocketError]);

    useEffect(() => {
        if (props.isSelect || props.isReply || props.isPreviewFile) {
            // clearHeight();
            props.setOpenSticker(false);
            props.setOpenRecordAudio(false);
        }
    }, [props.isSelect, props.isReply, props.isPreviewFile]);

    async function checkBlockedAccount(actionFunc) {
        if (groupInfo?.privacyLevel !== 4) {
            if (typeof actionFunc === "function") {
                actionFunc();
            }
            return;
        }
        let members = groupInfo?.members;
        let friend = members?.find((mem) => {
            return mem?.userID !== props.currentUserId;
        });
        let blockStatus = await blockedStatus.get(`/${friend?.userID}`);
        if (
            blockStatus?.id &&
            (blockStatus?.status === "blocked" || blockStatus?.status === "blocker")
        ) {
            warning({
                title: t("This user has blocked you"),
                content: t("you will  no longer be able to call or send you message") + ".",
            });
        } else {
            if (typeof actionFunc === "function") {
                actionFunc();
            }
            return;
        }
    }

    // useEffect(()=>{
    //   let membersList = [];
    //   // console.log("members: ", members);
    //   members.map((member) => {
    //     membersList.push({name:`${member.user?.firstname}`, lastname: `${member.user?.lastname ? member.user?.lastname : ""}`})
    //   })
    //   console.log("membersList: ", membersList);
    // }, [members])

    const onSelectUser = (option) => {

    }

    const checkMention = (message) => {
        const messageList = message.trim().split("!--!");
        const mentionDetails = [];
        let msgType = "text";
        let convertMsg = "";
        // const expMention = /@!\S+!/g;
        const expMention = /@!.+;.+!/g;

        for (let i in messageList) {
            if (i === 0) {
                msgType = "text";
                mentionDetails.push({
                    text: messageList[i],
                    type: msgType,
                })
                continue
            }
            console.log("messageList", messageList[i], messageList[i].match(expMention))
            if (messageList[i].match(expMention)) {
                let userData = messageList[i].substring(2, messageList[i].length - 1).split(";")
                console.log("userData", userData);
                const userName = userData.shift()
                const stringUserID = userData.join('-')
                const userObj = members.find((member) => {
                    return member.user?.id === stringUserID;
                });
                if (userObj) {
                    msgType = "mention";
                    const user = {
                        mention: {
                            link: userObj?.user?.id,
                            name: userObj?.user?.firstname,
                            user: {
                                profile: userObj?.user?.imageProfileURL,
                                username: userObj?.user?.firstname,
                            },
                            userId: userObj?.user?.id,
                        },
                    };

                    mentionDetails.push({
                        text: `@${userObj?.user?.firstname}`,
                        type: msgType,
                        user: user,
                    })
                    convertMsg += `@${userObj?.user?.firstname}`;
                } else {
                    msgType = "text";
                    mentionDetails.push({
                        text: messageList[i],
                        type: msgType,
                    })
                    convertMsg += messageList[i];
                }
            } else {
                msgType = "text";
                mentionDetails.push({
                    text: messageList[i],
                    type: msgType,
                })
                convertMsg += messageList[i];
            }
        }
        console.log(msgType)

        if (mentionDetails.length !== 0) {
            const mentionProperty = {
                mentionDetails,
                // mentionList,
                messageText: convertMsg,
            };
            console.log("mentionProperty: ", mentionProperty);
            return mentionProperty;
        } else {
            return null;
        }
    }

    const checkMentionDetail = (message) => {
        console.log("new message: ", message.trim().split(" "));
        const messageList = message.trim().split(/(\s+)/);
        console.log("messageList", messageList);
        const mentionDetails = [];
        const mentionList = [];
        let msgType = "text";

        const msgList = message.trim().split("@");

        for (let i in msgList) {
            if (i === 0) {
                msgType = "text";
                mentionDetails.push({
                    text: msgList[i],
                    type: msgType,
                })
                continue
            }

            const mentionUsers = members.find((member) => {
                let matchFirstname = msgList[i].match(member.user?.firstname);
                if (matchFirstname && matchFirstname.index === 0) {
                    return true;
                }
                return false;
                // let matchFullName = message.match(member.user?.firstname + " " + member.user?.lastname)
            });

            if (mentionUsers) {
                let mentionText = msgList[i].substring(0, mentionUsers?.user?.firstname.length);
                let otherText = msgList[i].substring(mentionUsers?.user?.firstname.length);
                msgType = "mention";
                const user = {
                    mention: {
                        link: mentionUsers?.user?.id,
                        name: mentionUsers?.user?.firstname,
                        user: {
                            profile: mentionUsers?.user?.imageProfileURL,
                            username: mentionUsers?.user?.firstname,
                        },
                        userId: mentionUsers?.user?.id,
                    },
                };

                mentionDetails.push({
                    text: "@" + mentionText,
                    type: msgType,
                    user: user,
                })

                msgType = "text";
                if (otherText) {
                    mentionDetails.push({
                        text: otherText,
                        type: msgType,
                    })
                }
            }
        }

        if (mentionDetails.length !== 0) {
            const mentionProperty = {
                mentionDetails,
                // mentionList,
                messageText: message,
            };
            console.log("mentionProperty: ", mentionProperty);
            return mentionProperty;
        } else {
            return null;
        }

        const mentionUsers = members.filter((member) => {
            return message.match("@" + member.user?.firstname + " ")
        });
        console.log("mentionUsers", mentionUsers)

        for (let i in mentionUsers) {
            msgType = "mention";
            const user = {
                mention: {
                    link: mentionUsers[i]?.user?.id,
                    name: mentionUsers[i]?.user?.firstname,
                    user: {
                        profile: mentionUsers[i]?.user?.imageProfileURL,
                        username: mentionUsers[i]?.user?.firstname,
                    },
                    userId: mentionUsers[i]?.user?.id,
                },
            };

            mentionDetails.push({
                text: "@" + mentionUsers[i]?.user?.firstname,
                type: msgType,
                user: user,
            })

        }

        if (mentionDetails.length !== 0) {
            const mentionProperty = {
                mentionDetails,
                // mentionList,
                messageText: message,
            };
            console.log("mentionProperty: ", mentionProperty);
            return mentionProperty;
        } else {
            return null;
        }


        //
        // for (let i = 0; i < messageList.length; i++) {
        //   if (messageList[i].charAt(0) === "@"){
        //
        //     const keyword = messageList[i].substring(1);
        //     const userObj = members.find((member) => {
        //       return member.user?.firstname === keyword;
        //     });
        //     console.log("keyword", keyword)
        //     console.log("userObj", groupInfo?.members, userObj)
        //     if (userObj !== undefined) {
        //       msgType = "mention";
        //       const user = {
        //         mention: {
        //           link: userObj?.user?.id,
        //           name: userObj?.user?.firstname,
        //           user: {
        //             profile: userObj?.user?.imageProfileURL,
        //             username: userObj?.user?.firstname,
        //           },
        //           userId: userObj?.user?.id,
        //         },
        //       };
        //
        //       mentionDetails.push({
        //         text: messageList[i],
        //         type: msgType,
        //         user: user,
        //       })
        //     } else {
        //       msgType = "text";
        //       mentionDetails.push({
        //         text: messageList[i],
        //         type: msgType,
        //       })
        //     }
        //
        //   } else {
        //     const userObj = members.find((member) => {
        //       return member.user?.lastname === messageList[i];
        //     });
        //     if (userObj !== undefined) {
        //       msgType = "mention";
        //       const user = {
        //         mention: {
        //           link: userObj?.user?.id,
        //           name: userObj?.user?.firstname,
        //           user: {
        //             profile: userObj?.user?.imageProfileURL,
        //             username: userObj?.user?.firstname,
        //           },
        //           userId: userObj?.user?.id,
        //         },
        //       };
        //
        //       mentionDetails.push({
        //         text: messageList[i],
        //         type: msgType,
        //         user: user,
        //       })
        //     } else {
        //       msgType = "text";
        //       mentionDetails.push({
        //         text: messageList[i],
        //         type: msgType,
        //       })
        //     }
        //   }
        // }
        //
        // if (mentionDetails.length !== 0) {
        //   const mentionProperty = {
        //     mentionDetails,
        //     // mentionList,
        //     messageText: message,
        //   };
        //   console.log("mentionProperty: ", mentionProperty);
        //   return mentionProperty;
        // } else {
        //   return null;
        // }
    }

    // const checkMentionDetail = (message) => {
    //   const mentionDetails = [];
    //   const mentionList = [];
    //   let startIdx = 0;
    //   let msgType = "text";
    //   let collecting = false;

    //   for (let i = 0; i < message.length; i++) {
    //     if (message.charAt(i) === "@") {
    //       if (i !== 0) {
    //         mentionDetails.push({
    //           text: message.substring(startIdx, i),
    //           type: msgType,
    //         });
    //       }
    //       msgType = "mention";
    //       startIdx = i;
    //       collecting = true;
    //     }

    //     if (collecting && message.charAt(i) === " ") {
    //       const keyword = message.substring(startIdx + 1, i);
    //       const userObj = members.find((member) => {
    //         return member.user?.firstname === keyword;
    //       });
    //       const user = {
    //         mention: {
    //           link: userObj?.user?.id,
    //           name: userObj?.user?.firstname,
    //           user: {
    //             profile: userObj?.user?.imageProfileURL,
    //             username: userObj?.user?.firstname,
    //           },
    //           userId: userObj?.user?.id,
    //         },
    //       };

    //       mentionDetails.push({
    //         text: message.substring(startIdx, i),
    //         type: msgType,
    //         user: user,
    //       });

    //       mentionList.push({
    //         link: userObj?.user?.id,
    //         name: userObj?.user?.firstname,
    //         user: {
    //           profile: userObj?.user?.imageProfileURL,
    //           username: userObj?.user?.firstname,
    //         },
    //         userId: userObj?.user?.id,
    //       });

    //       msgType = "text";
    //       startIdx = i;
    //       collecting = false;
    //     }
    //   }

    //   if (mentionDetails.length !== 0) {
    //     const mentionProperty = {
    //       mentionDetails,
    //       mentionList,
    //       messageText: message,
    //     };
    //     // console.log("mentionProperty: ", mentionProperty);
    //     return mentionProperty;
    //   } else {
    //     return null;
    //   }
    // };

    //================= Save new message =================
    const handleSendMessage = async (messageType) => {
        console.log("Message sending....");
        const msgInput = inputMessage;
        const messageTime = moment(new Date()).format();
        const tempMsgId = create_UUID();
        let objectReply = {};
        if (msgInput.match(regexURL)) {
            messageType = messageTypes.Link;
        }
        const mentionProperty = checkMention(msgInput);
        setInputMessage("");
        if (props.isReply) objectReply = props.notiMessage;
        const replyId = objectReply?.messageId || "";
        const msgBody = {
            groupId: props.currentGroupId,
            messageType: messageType,
            messageText: mentionProperty.messageText,
            messageReplyId: replyId,
            messageDetails: !_.isEmpty(objectReply) ? objectReply : {},
            refID: tempMsgId,
            mentionProperty,
        };
        if (props.isReply) props.handleCloseNoti();
        await props.setNewMessageList((prevState) =>
            _.concat(
                {
                    messageStatus: sendStatus.Sending,
                    userId: props.currentUserId,
                    groupId: props.currentGroupId,
                    messageType: messageType,
                    messageText: mentionProperty.messageText,
                    messageTime: messageTime,
                    messageId: tempMsgId,
                    messageRefId: tempMsgId,
                    messageReplyId: replyId || "",
                    messageReplyDetails: [objectReply],
                    messageDetails: !_.isEmpty(objectReply) ? objectReply : {},
                    __v: 0,
                },
                prevState
            )
        );
        props.setScrollDirection({
            direct: 1,
            event: sendStatus.Update,
            objData: null,
        });
        props.handleSave(msgBody);
    };

    const onFileChange = async (event) => {
        if (!event?.target?.files || event?.target?.files.length < 1) return;
        console.log("onFileChange");
        const regexVideo = new RegExp(expVideo);
        const regexAudio = new RegExp(expAudio);
        const regexImage = new RegExp(expImgges);
        let fileName = "";
        let fileType = "";
        let messageType = "";
        const files = event?.target?.files;
        for (let item of files) {
            fileName = item?.name;
            fileType = getFileType(fileName);
            if (fileType.match(regexVideo)) {
                messageType = messageTypes.Video;
            } else if (fileType.match(regexImage)) {
                messageType = messageTypes.Image;
                let localURL = [];
                let filesImg = [];
                let fileSize = item?.size;
                let mimeType = item?.type;
                filesImg.push(item);
                localURL.push(item);
                if (filesImg.length === 8) {
                    const tempMsgId = create_UUID();
                    pushLocalMessageFileMedia(
                        messageTypes.Image,
                        filesImg,
                        tempMsgId,
                        "",
                        localURL,
                        fileType,
                        fileName,
                        fileSize,
                        mimeType
                    );
                    filesImg = [];
                    localURL = [];
                }
                if (filesImg.length > 0) {
                    const tempMsgId = create_UUID();
                    pushLocalMessageFileMedia(
                        messageTypes.Image,
                        filesImg,
                        tempMsgId,
                        "",
                        localURL,
                        fileType,
                        fileName,
                        fileSize,
                        mimeType
                    );
                }
                continue
            } else if (fileType.match(regexAudio)) {
                messageType = messageTypes.Audio;
            } else {
                messageType = messageTypes.CenterFlie;
            }
            const tempMsgId = create_UUID();
            await pushLocalMessageFileMedia(
                messageType,
                [item],
                tempMsgId,
                "",
                [URL.createObjectURL(item)],
                fileType,
                fileName
            );
        }
    };

    const getFileType = (fileName) => {
        return fileName?.substr(fileName?.lastIndexOf(".") + 1, fileName.length);
    };

    const onFileMediaChange = async (event) => {
        setLoadingFile(true);
        
        const files = event?.target?.files;
        console.log("file drop : ", files);
        if (!files || files.length < 1) return;
        const regexVideo = new RegExp(expVideo);
        const regexAudio = new RegExp(expAudio);
        const regexImage = new RegExp(expImgges);
        let fileName = "";
        let fileType = "";
        let messageType = "";
        for (let item of files) {
            fileName = item?.name;
            fileType = getFileType(fileName);
            let fileSize = item?.size;
            let mimeType = item?.type;
            if (fileType.match(regexVideo)) {
                messageType = messageTypes.Video;
            } else if (fileType.match(regexImage)) {
                messageType = messageTypes.Image;
                let localURL = [];
                let filesImg = [];
                filesImg.push(item);
                localURL.push(item);
                if (filesImg.length === 8) {
                    const tempMsgId = create_UUID();
                    await pushLocalMessageFileMedia(
                        messageTypes.Image,
                        filesImg,
                        tempMsgId,
                        "",
                        localURL,
                        fileType,
                        fileName,
                        fileSize,
                        mimeType
                    );
                    filesImg = [];
                    localURL = [];
                }
                if (filesImg.length > 0) {
                    const tempMsgId = create_UUID();
                    await pushLocalMessageFileMedia(
                        messageTypes.Image,
                        filesImg,
                        tempMsgId,
                        "",
                        localURL,
                        fileType,
                        fileName,
                        fileSize,
                        mimeType
                    );
                }
                continue
            } else if (fileType.match(regexAudio)) {
                messageType = messageTypes.Audio;
            } else {
                messageType = messageTypes.CenterFlie;
            }
            const tempMsgId = create_UUID();
            await pushLocalMessageFileMedia(
                messageType,
                [item],
                tempMsgId,
                "",
                [URL.createObjectURL(item)],
                fileType,
                fileName,
                fileSize,
                mimeType
            );
        }


        // if (!event?.target?.files || event?.target?.files.length < 1) return;
        // console.log("onFileMediaChange");
        // const regexVideo = new RegExp(expVideo);
        // const regexAudio = new RegExp(expAudio);
        // const regexImage = new RegExp(expImgges);
        // let fileName = "";
        // let fileType = "";
        // let messageType = "";
        // let localURL = [];
        // let filesImg = [];
        // let mimeType = "";
        // let fileSize = 0;
        // const files = event?.target?.files;
        // console.log("onFileMediaChange files :", files.length);
        // console.log("onFileMediaChange files>> ",files);
        // // if (files.length === 1) {
        // //   fileName = files[0]?.name;
        // //   fileType = getFileType(fileName);
        // //   if (fileType.match(regexVideo)) {
        // //     messageType = messageTypes.Video;
        // //   } else if (fileType.match(regexAudio)) {
        // //     messageType = messageTypes.Audio;
        // //   } else {
        // //     messageType = messageTypes.Image;
        // //   }
        // //   const tempMsgId = create_UUID();
        // //   localURL.push(URL.createObjectURL(files[0]));
        // //   filesImg.push(files[0]);
        // //   await pushLocalMessageFileMedia(
        // //     messageType,
        // //     filesImg,
        // //     tempMsgId,
        // //     "",
        // //     localURL,
        // //     ""
        // //   );
        // //   return;
        // // }
        // for (let item of files) {
        //     fileName = item?.name;
        //     fileType = getFileType(fileName);
        //     fileSize = item?.size;
        //     mimeType = item?.type;
        //     if (fileType.match(regexVideo)) {
        //         const tempMsgId = create_UUID();
        //         await pushLocalMessageFileMedia(
        //             messageTypes.Video,
        //             [item],
        //             tempMsgId,
        //             "",
        //             [URL.createObjectURL(item)],
        //             fileType,
        //             fileName,
        //             fileSize,
        //             mimeType
        //         );
        //     } else if (fileType.match(regexAudio)) {
        //         const tempMsgId = create_UUID();
        //         await pushLocalMessageFileMedia(
        //             messageTypes.Audio,
        //             [item],
        //             tempMsgId,
        //             "",
        //             [URL.createObjectURL(item)],
        //             fileType,
        //             fileName,
        //             fileSize,
        //             mimeType
        //         );
        //     } else {
        //         filesImg.push(item);
        //         localURL.push(item);
        //         if (filesImg.length === 8) {
        //             const tempMsgId = create_UUID();
        //             pushLocalMessageFileMedia(
        //                 messageTypes.Image,
        //                 filesImg,
        //                 tempMsgId,
        //                 "",
        //                 localURL,
        //                 fileType,
        //                 fileName,
        //                 fileSize,
        //                 mimeType
        //             );
        //             filesImg = [];
        //             localURL = [];
        //         }
        //     }
        // }
        // if (filesImg.length > 0) {
        //     const tempMsgId = create_UUID();
        //     pushLocalMessageFileMedia(
        //         messageTypes.Image,
        //         filesImg,
        //         tempMsgId,
        //         "",
        //         localURL,
        //         fileType,
        //         fileName,
        //         fileSize,
        //         mimeType
        //     );
        // }
    };

    const pushLocalMessageFileMedia = async (
        messageType,
        messageDetails,
        tempMsgId,
        messageText,
        localURL,
        fileType,
        fileName,
        fileSize,
        mimeType
    ) => {
        console.log("pushLocalMessageFileMedia");
        const messageTime = moment(new Date()).format();
        let objDetails;
        if (messageType === messageTypes.CenterFlie)
            objDetails = {
                fileDetails: localURL,
                fileType: fileType,
                fileName: fileName,
                size: fileSize,
                mimeType: mimeType,
            };
        if (messageType === messageTypes.Image)
            objDetails = { imageDetails: localURL };
        if (messageType === messageTypes.Audio)
            objDetails = { audioDetails: localURL };
        if (messageType === messageTypes.Video)
            objDetails = { videoDetails: localURL };
        if (messageType === messageTypes.Sticker) objDetails = messageDetails;
        if (messageType === messageTypes.Sound)
            objDetails = { soundDetails: [messageDetails] };

        const tempSendImg = {
            messageStatus: sendStatus.Sending,
            userId: props.currentUserId,
            groupId: props.currentGroupId,
            messageType: messageType,
            messageText: messageText,
            messageTime: messageTime,
            messageId: tempMsgId,
            messageRefId: tempMsgId,
            messageDetails: objDetails,
            messageURLlocal: objDetails,
            stampUpload: 0,
            __v: 0,
        };
        await props.setNewMessageList((prevState) =>
            _.concat(tempSendImg, prevState)
        );
        if (
            messageType !== messageTypes.Image &&
            messageType !== messageTypes.Sticker
        ) {
            uploadCenterFile(messageType, messageDetails, tempMsgId);
            props.setScrollDirection({
                direct: 1,
                event: sendStatus.Update,
                objData: null,
            });
            return;
        }
        if (messageType === messageTypes.Image) {
            uploadImageFile(messageType, messageDetails, tempMsgId);
            props.setScrollDirection({
                direct: 1,
                event: sendStatus.Update,
                objData: null,
            });
            return;
        }
        const msgBody = {
            groupId: props.currentGroupId,
            messageType: messageType,
            messageText: messageText,
            messageDetails: objDetails,
            refID: tempMsgId,
        };
        props.setScrollDirection({
            direct: 1,
            event: sendStatus.Update,
            objData: null,
        });
        await props.handleSave(msgBody);
    };

    function checkUnload(e) {
        var confirmationMessage = "Are u sure?";
        e.returnValue = confirmationMessage;
        return confirmationMessage;
    }

    const onUploadProgress = (progressEvent, tempMsgId) => {
        var percent = (progressEvent.loaded / progressEvent.total) * 100;
        if (percent > 100) percent = 100;
        window.addEventListener("beforeunload", checkUnload);
        percent = Math.round(percent);
        props.setUploadProgress((prevState) => {
            if (
                prevState?.length === 0 ||
                prevState.filter((item) => item?.tempMsgId === tempMsgId).length === 0
            ) {
                return [
                    ...prevState,
                    {
                        tempMsgId: tempMsgId,
                        progress: percent,
                    },
                ];
            } else {
                return prevState.map((item) =>
                    item?.tempMsgId === tempMsgId
                        ? Object.assign({}, item, {
                            progress: percent,
                        })
                        : item
                );
            }
        });
    };



    // useEffect(() => {
    //     console.log("loadingFile : ", loadingFile);
    //     const unloadCallback = (event) => {
    //         event.preventDefault();
    //         event.returnValue = "Sure";
    //         return "Sure";
    //     };

    //     if (loadingFile) {
    //         window.addEventListener("beforeunload", unloadCallback);
    //     }
    //     return () => window.removeEventListener("beforeunload", unloadCallback);
    // }, [loadingFile]);


    const uploadCenterFile = async (filesType, filesObj, tempMsgId) => {
        console.log("uploadCenterFile");
        let responseData;
        const fileDetails = [];
        let files =
            filesType === messageTypes.Sound ? [filesObj?.objFile] : filesObj;
        /*
        let data = new FormData();
        data.append("file", files[0]);
        data.append("fullName", files[0]?.name);
        data.append(
          "fileName",
          files[0]?.name?.substr(0, files[0]?.name?.lastIndexOf("."))
        );
        data.append(
          "fileType",
          files[0]?.name?.substr(
            files[0]?.name?.lastIndexOf(".") + 1,
            files[0]?.name?.length
          )
        );
        data.append("size", files[0]?.size);
        data.append("groupId", props.currentGroupId);
        data.append("parent_folder_id", "");
        data.append("actionType", "chat");*/
        // responseData = await apiUploadFile.post(data);

        let groupId = props.currentGroupId;
        let hash = uuidv4();
        let axiosPromiseArray = [];
        let file = files[0];
        let temp = getClassAndType(file.name);
        let useName = await getFinalNameChat(
            temp.name_,
            temp.type_,
            groupId,
            "chat"
        );
        let blockCount = Math.ceil(file.size / chunkSize);
        let loaded = 0;
        for (let i = 0; i < blockCount; i++) {
            let CancelToken = axios.CancelToken;
            let cancel;
            const start = i * chunkSize;
            const end = Math.min(file.size, start + chunkSize);

            const form = new FormData();
            let blobSlice = File.prototype.slice;
            form.append("file", blobSlice.call(file, start, end));
            form.append("name", useName);
            //@ts-ignore
            form.append("total", blockCount);
            //@ts-ignore
            form.append("index", i);
            form.append("size", file.size);
            //@ts-ignore
            form.append("hash", hash);


            let config = {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                }),
                onUploadProgress: (progress) => {
                    let progressTemp = {};
                    loaded = loaded + progress.loaded;
                    progressTemp.total = file.size;
                    progressTemp.loaded = loaded;
                    if (progress.loaded === progress.total) {
                        loaded = loaded + progress.total;
                    }

                    onUploadProgress(progressTemp, tempMsgId);
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            };
            let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/uploadSplit";
            axiosPromiseArray.push(axios.post(link, form, config));
        }

        axios
            .all(axiosPromiseArray)
            .then(() => {
                let CancelToken = axios.CancelToken;
                let cancel;

                let config = {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    }),
                    onUploadProgress: (progress) => {
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: getAuthorization(),
                    },
                };

                let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/merge_chunks";

                const data = {
                    size: file.size,
                    name: useName + "." + temp.type_,
                    total: blockCount,

                    fileName: useName,
                    userId: null,
                    groupId: groupId,
                    parentFolderId: "",
                    cancelCheckOut: null,
                    cancelCheckOutFileId: null,
                    hash: hash,
                    mimeType: file.type,
                    actionType: "chat",
                    convertMp3: filesType === messageTypes.Sound
                };
                axios
                    .post(link, data, config)
                    .then((response) => {
                        console.log("successful upload", response);
                        window.removeEventListener("beforeunload", checkUnload);
                        if (response?.data?.success) {
                            if (filesType === messageTypes.Sound) {
                                let objData = {
                                    id: response?.data?.data.id,
                                    fileName: response?.data?.data.fileName,
                                    fileType: response?.data?.data.fileType,
                                    group_id: response?.data?.data.group_id,
                                    timeRecord: filesObj?.timeRecord,
                                    mimeType: response?.data?.data.mime_type,
                                    size: response?.data?.data.size_,
                                };
                                fileDetails.push(objData);
                            } else {
                                let objData = {
                                    id: response?.data?.data.id,
                                    fileName: response?.data?.data.fileName,
                                    fileType: response?.data?.data.fileType,
                                    group_id: response?.data?.data.group_id,
                                    mimeType: response?.data?.data.mime_type,
                                    size: response?.data?.data.size_,
                                };
                                fileDetails.push(objData);
                            }
                            const msgBody = {
                                groupId: props.currentGroupId,
                                messageType: filesType,
                                messageText: "",
                                messageDetails:
                                    filesType === messageTypes.CenterFlie
                                        ? { fileDetails: fileDetails }
                                        : filesType === messageTypes.Video
                                            ? { videoDetails: fileDetails }
                                            : filesType === messageTypes.Audio
                                                ? { audioDetails: fileDetails }
                                                : { soundDetails: fileDetails },
                                refID: tempMsgId,
                            };
                            props.handleSave(msgBody);
                            console.log("Uploading success.");
                        } else {
                            if (response?.status === 400) {
                                warning({
                                    title: t("Upload Failed"),
                                    content: t(response.message),
                                });
                                props.setNewMessageList((prevState) =>
                                    prevState.map((item) =>
                                        item.messageId === tempMsgId
                                            ? Object.assign({}, item, {
                                                messageStatus: sendStatus.SendFail,
                                            })
                                            : item
                                    )
                                );
                                deleteFileInChatStorage(filesType, fileDetails);
                                return;
                            }
                        }
                    })
                    .catch(function (error) {
                        console.warn("Error UploadFile : ", error);
                        warning({
                            title: t("Upload Failed"),
                            content: t(error),
                        });
                        props.setNewMessageList((prevState) =>
                            prevState.map((item) =>
                                item.messageId === tempMsgId
                                    ? Object.assign({}, item, {
                                        messageStatus: sendStatus.SendFail,
                                    })
                                    : item
                            )
                        );
                        return;
                    })
                    .finally(function () {
                        console.log("finally upload");
                        setLoadingFile(false);
                    });
            })
            .catch(function (error) {
            });

        /*
        let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/upload";
        let CancelToken = axios.CancelToken;
        let cancel;
        let config = {
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          }),
          onUploadProgress: (progress) => {
            onUploadProgress(progress, tempMsgId);
          },
          headers: {
            "CenterContent-Type": "application/json",
            Authorization: getAuthorization(),
          },
        };
        axios
          .post(link, data, config)
          .then(function (response) {
            if (response?.data?.success) {
              if (filesType === messageTypes.Sound) {
                let objData = {
                  id: response?.data?.data.id,
                  fileName: response?.data?.data.fileName,
                  fileType: response?.data?.data.fileType,
                  group_id: response?.data?.data.group_id,
                  timeRecord: filesObj?.timeRecord,
                  mimeType: response?.data?.data.mime_type,
                  size: response?.data?.data.size_,
                };
                fileDetails.push(objData);
              } else {
                let objData = {
                  id: response?.data?.data.id,
                  fileName: response?.data?.data.fileName,
                  fileType: response?.data?.data.fileType,
                  group_id: response?.data?.data.group_id,
                  mimeType: response?.data?.data.mime_type,
                  size: response?.data?.data.size_,
                };
                fileDetails.push(objData);
              }
              const msgBody = {
                groupId: props.currentGroupId,
                messageType: filesType,
                messageText: "",
                messageDetails:
                  filesType === messageTypes.CenterFlie
                    ? { fileDetails: fileDetails }
                    : filesType === messageTypes.Video
                    ? { videoDetails: fileDetails }
                    : filesType === messageTypes.Audio
                    ? { audioDetails: fileDetails }
                    : { soundDetails: fileDetails },
                refID: tempMsgId,
              };
              props.handleSave(msgBody);
              console.log("Uploading success.");
            } else {
              if (responseData?.status === 400) {
                warning({
                  title: t("Upload Failed"),
                  content: t(responseData.message),
                });
                props.setNewMessageList((prevState) =>
                  prevState.map((item) =>
                    item.messageId === tempMsgId
                      ? Object.assign({}, item, {
                          messageStatus: sendStatus.SendFail,
                        })
                      : item
                  )
                );
                deleteFileInChatStorage(filesType, fileDetails);
                return;
              }
            }
          })
          .catch(function (error) {
            console.warn("Error UploadFile : ", error);
            warning({
              title: t("Upload Failed"),
              content: t(error),
            });
            props.setNewMessageList((prevState) =>
              prevState.map((item) =>
                item.messageId === tempMsgId
                  ? Object.assign({}, item, {
                      messageStatus: sendStatus.SendFail,
                    })
                  : item
              )
            );
            return;
          })
          .finally(function () {
            props.setUploadProgress((prevState) =>
              prevState.filter((item) => item.tempMsgId !== tempMsgId)
            );
          });*/
    };

    const uploadImageFile = async (filesType, filesObj, tempMsgId) => {
        console.log("uploadImageFile");
        const fileDetails = [];
        let isSuccess = true;
        let objFile = [];
        let files =
            filesType === messageTypes.Sound ? [filesObj?.objFile] : filesObj;
        let count = 0;
        for (let item of files) {
            let data = new FormData();
            /*
            data.append("file", item);
            data.append("fullName", item?.name);
            data.append("fileName", item?.name?.split(".")[0]);
            data.append("fileType", item?.name?.split(".")[1]);
            data.append("size", item?.size);
            data.append("groupId", props.currentGroupId);
            data.append("parent_folder_id", "");
            data.append("actionType", "chat");
            */
            objFile.push({
                fileData: data,
                data: item,
            });
        }
        const messageGroupImageId = create_UUID();
        let messageId = "";
        for (let item of objFile) {
            let responseData;
            try {
                // responseData = await apiUploadFile.post(item.fileData);
                responseData = await uploadFileRequestChunkChat(
                    item.data,
                    props.currentGroupId
                );

                if (responseData?.success) {
                    let objData = {
                        id: responseData.data.id,
                        fileName: responseData.data.fileName,
                        fileType: responseData.data.fileType,
                        group_id: responseData.data.group_id,
                    };
                    fileDetails.push(objData);
                    if (count === 0) {
                        count++;
                        const msgBody = {
                            groupId: props.currentGroupId,
                            messageType: filesType,
                            messageGroupImageId: messageGroupImageId,
                            messageText: "",
                            messageDetails: { imageDetails: fileDetails },
                            stampUpload: objFile.length === 1 ? 1 : 0,
                            refID: tempMsgId,
                        };
                        messageId = await props.handleSave(msgBody);
                    } else {
                        const msgBody = {
                            groupId: props.currentGroupId,
                            messageId: messageId,
                            messageGroupImageId: messageGroupImageId,
                            messageText: "",
                            messageDetails: { imageDetails: fileDetails },
                            stampUpload: count === objFile?.length - 1 ? objFile?.length : 0,
                            refID: tempMsgId,
                        };
                        await hendleSaveMessageImage(msgBody);
                        count++;
                    }
                    console.log("Uploading success.");
                } else {
                    isSuccess = false;
                    if (responseData?.status === 400) {
                        warning({
                            title: t("Upload Failed"),
                            content: t(responseData.message),
                        });
                        props.setNewMessageList((prevState) =>
                            prevState.map((item) =>
                                item.messageId === tempMsgId
                                    ? Object.assign({}, item, {
                                        messageStatus: sendStatus.SendFail,
                                    })
                                    : item
                            )
                        );
                        deleteFileInChatStorage(filesType, fileDetails);
                        return;
                    }
                }
            } catch (error) {
                isSuccess = false;
                console.warn("Error UploadFile : ", error);
                warning({
                    title: t("Upload Failed"),
                    content: t(error),
                });
                props.setNewMessageList((prevState) =>
                    prevState.map((item) =>
                        item.messageId === tempMsgId
                            ? Object.assign({}, item, {
                                messageStatus: sendStatus.SendFail,
                            })
                            : item
                    )
                );
                return;
            }
        }
        if (filesType === messageTypes.Image) return;
        const msgBody = {
            groupId: props.currentGroupId,
            messageType: filesType,
            messageText: "",
            messageDetails: { imageDetails: fileDetails },
            refID: tempMsgId,
        };
        if (isSuccess) await props.handleSave(msgBody);
    };

    const hendleSaveMessageImage = async (msgBody) => {
        let responseData;
        try {
            responseData = await apiSaveMessageImage.post(msgBody);
            console.log("hendleSaveMessageImage : ", responseData);
        } catch (e) {
            console.warn("Error hendleSaveMessageImage : ", e);
        }
    };

    //================= API Delete File in Chat =================
    const deleteFileInChatStorage = async (messageType, messageDetails) => {
        if (messageType === messageTypes.Video) {
            await apiDeleteFile.post({
                fileId: messageDetails.videoDetails[0].id,
            });
        } else if (messageType === messageTypes.Sound) {
            await apiDeleteFile.post({
                fileId: messageDetails.soundDetails[0].id,
            });
        } else {
            const imageDetails = messageDetails.imageDetails;
            for (let imgItem of imageDetails) {
                props.handleDeleteImageInStorage(imgItem.id);
                await apiDeleteFile.post({ fileId: imgItem.id });
            }
        }
    };

    const hendleActiveSticker = () => {
        if (!props.isOpenSticker) {
            props.setOpenControl(false);
            props.setOpenRecordAudio(false);
            props.setOpenSticker(true);
            return;
        }
        props.setOpenSticker(false);
    };

    const hendleSendSticker = (data) => {
        const tempMsgId = create_UUID();
        const srcImage =
            data.type === "default"
                ? document
                    .getElementById("defaultSticker_" + data.packageId + data.url)
                    .getAttribute("src").replace(process.env.PUBLIC_URL, "")
                : data.url;
        const stickerDetail = {
            type: data.type,
            stickerId:
                data.type === "default"
                    ? "defaultSticker_" + data.packageId + data.url
                    : data.stickerId,
            packageId: data.packageId,
            transactionId: data.transactionId,
        };
        // console.log("srcImage", srcImage, document
        //     .getElementById("defaultSticker_" + data.packageId + data.url)
        //     .getAttribute("src"));
        pushLocalMessageFileMedia(
            messageTypes.Sticker,
            stickerDetail,
            tempMsgId,
            srcImage
        );
    };

    const clearHeight = () => {
        if (!checkEmpty(messageRef)) messageRef.style.height = "25px";
    };

    const clear = () => {
        var event = {
            FAKE_EVENT: true,
            target: messageRef,
        };
        messageRef.value = "";
        messageRef.onChange(event);
    };

    const handleEventSendSticker = (data) => {
        checkBlockedAccount(() => hendleSendSticker(data));
    };

    return (
        <div className={styles.groupToolbar}>
            <div className={styles.groupBottom}>
                <div className={styles.inputMsg}>
                    <UIMessageInput
                        id="chat-message-input"
                        value={inputMessage}
                        currentUserId={props.currentUserId}
                        members={members}
                        multiline={true}
                        onKeyPress={(e) => {
                            if (e.which === 13 && !e.shiftKey) {
                                refSend.current.click();
                                e.preventDefault();
                            }
                            if (e.which === 13 && e.shiftKey) {
                                e.stopPropagation();
                            }
                        }}
                        autoHeight={true}
                        inputRef={setRef}
                        maxHeight={120}
                        minHeight={27}
                        placeholder="Aa"
                        maxlength="500"
                        onBlur={() => {
                            const text = inputMessage;
                            if (text.trim().length > 0) {
                                // clearHeight();
                            }
                        }}
                        inputStyle={{
                            background: "transparent",
                            maxHeight: "80px",
                            width: "calc(100% - 35px)",
                            paddingLeft: "5px",
                            marginTop: "5px",
                        }}
                        onChange={(e) => {
                            console.log("onChange", e.target.value);
                            setInputMessage(e.target.value);
                        }}
                        onSelect={(option, prefix) => {
                            onSelectUser(option);
                        }}
                        onClick={() => {
                            if (!props.isSelect && !props.loadingData) {
                                props.setOpenSticker(false);
                                props.setOpenRecordAudio(false);
                                props.setScrollDirection({
                                    direct: 1,
                                    event: sendStatus.Update,
                                    objData: null,
                                });
                            }
                        }}
                        rightButtons={
                            <Popover
                                visible={props.isOpenSticker}
                                placement="topRight"
                                content={
                                    <UIGroupSticker
                                        isOpenSticker={props.isOpenSticker}
                                        hendleActiveSticker={() => props.setOpenSticker(false)}
                                        hendleSendSticker={handleEventSendSticker}
                                        key={"UIGroupSticker_"}
                                    />
                                }
                            >
                                <Button
                                    ref={refSticker}
                                    type="link"
                                    size={"middle"}
                                    id="btn-group-sticker"
                                    style={{
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }}
                                    className={styles.btnGroupSticker}
                                    onClick={() => {
                                        console.log("inputMessage", inputMessage)
                                        const text = inputMessage;
                                        if (text.trim().length > 0) {
                                            // clearHeight();
                                        }
                                        hendleActiveSticker();
                                    }}
                                >
                                    <img
                                        alt="preload"
                                        src={stickerBtn}
                                        style={{
                                            height: "28px",
                                            width: "28px",
                                            marginBottom: "6px",
                                            marginTop: "-4px",
                                        }}
                                    />
                                </Button>
                            </Popover>
                        }
                        leftButtons={
                            <>
                                <Button
                                    ref={refMedia}
                                    shape="circle"
                                    id="btn-group-photo"
                                    style={{
                                        height: "32px",
                                        width: "32px",
                                        marginRight: "5px",
                                    }}
                                    onClick={() => {
                                        props.setOpenSticker(false);
                                        props.setOpenRecordAudio(false);
                                        const text = inputMessage;
                                        if (text.trim().length > 0) {
                                            // clearHeight();
                                        }
                                        if (refInputMedia.current) {
                                            refInputMedia.current.value = "";
                                            refInputMedia.current.click();
                                            return true;
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon
                                        className="font-awesome"
                                        icon={faPhotoVideo}
                                        style={{
                                            color: "rgb(193 192 192)",
                                            width: "16px",
                                            height: "16px",
                                            margin: "auto",
                                        }}
                                    />
                                    <input
                                        type="file"
                                        accept="image/*,video/*,audio/*"
                                        ref={refInputMedia}
                                        onChange={(e) => onFileMediaChange(e)}
                                        multiple={true}
                                        style={{ display: "none" }}
                                    />
                                </Button>
                                <Button
                                    ref={refFile}
                                    shape="circle"
                                    id="btn-group-photo"
                                    style={{
                                        height: "32px",
                                        width: "32px",
                                    }}
                                    onClick={() => {
                                        props.setOpenSticker(false);
                                        props.setOpenRecordAudio(false);
                                        const text = inputMessage;
                                        if (text.trim().length > 0) {
                                            // clearHeight();
                                        }
                                        if (refInputFile.current) {
                                            refInputFile.current.value = "";
                                            refInputFile.current.click();
                                            return true;
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon
                                        className="font-awesome"
                                        icon={faPaperclip}
                                        style={{
                                            color: "rgb(193 192 192)",
                                            width: "16px",
                                            height: "16px",
                                            margin: "auto",
                                        }}
                                    />
                                    <input
                                        type="file"
                                        ref={refInputFile}
                                        onChange={(e) => onFileChange(e)}
                                        accept="file_extension"
                                        multiple={true}
                                        style={{ display: "none" }}
                                    />
                                </Button>
                            </>
                        }
                    />
                </div>
                <div className={styles.btnMicSend}>
                    {inputMessage.trim().length === 0 ? (
                        <Popover
                            visible={props.isOpenRecordAudio}
                            placement="topRight"
                            content={
                                <UIGroupAudio
                                    isOpenRecordAudio={props.isOpenRecordAudio}
                                    setOpenRecordAudio={props.setOpenRecordAudio}
                                    key={"UIGroupAudio_"}
                                    pushLocalMessageFileMedia={pushLocalMessageFileMedia}
                                />
                            }
                        >
                            <Button
                                type="link"
                                ref={refMic}
                                id="btn-record-audio"
                                style={
                                    inputMessage?.trim().length !== 0
                                        ? { display: "none" }
                                        : { display: "inline" }
                                }
                                onClick={() => {
                                    if (props.isOpenRecordAudio) {
                                        props.setOpenRecordAudio(false);
                                    } else {
                                        const text = inputMessage;
                                        if (text.trim().length > 0) {
                                            // clearHeight();
                                        }
                                        props.setOpenSticker(false);
                                        props.setOpenControl(false);
                                        props.setOpenRecordAudio(true);
                                    }
                                }}
                            >
                                <img
                                    alt="preload"
                                    src={!props.isOpenRecordAudio ? mic : unMic}
                                    style={{
                                        width: "19px",
                                        height: "28px",
                                        marginTop: "-8px",
                                    }}
                                />
                            </Button>
                        </Popover>
                    ) : (
                        <Button
                            type="link"
                            id="btn-send-text"
                            ref={refSend}
                            style={
                                inputMessage?.trim().length === 0
                                    ? { display: "none" }
                                    : { display: "inline" }
                            }
                            onClick={async () => {
                                props.setOpenSticker(false);
                                const text = inputMessage;
                                if (text.trim().length > 0) {
                                    // document.getElementById("chat-message-input").focus();
                                    // clear();
                                    await handleSendMessage("text");
                                    setInputMessage("");
                                }
                            }}
                        >
                            <FontAwesomeIcon
                                className="font-awesome"
                                icon={faPaperPlane}
                                style={{ color: "#0f4c82", width: "20px", height: "20px" }}
                            />
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default React.memo(UIChatToolbar);
